<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import PendingModificationItems from "@/router/views/office/office-widgets/pending.vue";
import PostedModificationItems from "@/router/views/office/office-widgets/posted.vue";
import ReturnedModificationItems from "@/router/views/office/office-widgets/returned.vue";
import ApprovedModificationItems from "@/router/views/office/office-widgets/approved.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import ApiResourceLogs from "@/components/modals/api-resource-logs.vue";
import ProfileCropper from "@/components/modals/profile-cropper.vue";
import ResourceUpdate from "@/router/views/office/office-widgets/actual-resource-item.vue";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import RawData from "@/components/widgets/raw-data.vue";
import ViewItems from "@/components/modals/modification-items.vue"
import RealignmentRemarks from "@/components/modals/realignment-remarks.vue";

export default {
    name: 'ItemResources',
    components: {
        Layout,
        PageHeader,
        PendingModificationItems,
        PostedModificationItems,
        ReturnedModificationItems,
        ApprovedModificationItems,
        ApiResourceLogs,
        PrintOptions,
        ProfileCropper,
        ResourceUpdate,
        MaskedInput,
        RawData,
        ViewItems,
        RealignmentRemarks
    },
    data() {
        return {
            title: 'My Item Resources',
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: 'My Item Resources',
                    active: true,
                },
            ],
            currencyMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: false,
                allowDecimal: false,
            }),
            tableBusy: false,
            filter: "",
            pageOptions: [5, 10, 25, 50, 100],
            perPage: 5,
            currentPage: 1,
            tableData: [],
            totalReduceQty: 0,
            reducedQty: [],
            modificationNo: 0,
            runAnimation: false,
            pendingRealignment: [],
            postedRealignments: [],
            realignments: [],
            selectedTransfer: null,
            draftRealignment: null,
            approveLoading: false,
            realigmentLoading: false,
            openModificationModal: false,
            selectedApiId: null,
        }
    },
    computed: {
        filtered(){
            let data = this.tableData;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows(){
            let data = this.tableData;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        },
    },
    async created() {
        this.getItemResources(this.$store.state.data.cycle, this.$store.state.data.selectedDepartment.id);
        this.getPendingRealignment(this.$store.state.data.cycle, this.$store.state.data.selectedDepartment.id)
        this.getRealignments(this.$store.state.data.cycle, this.$store.state.data.selectedDepartment.id)
    },
    mounted(){
        this.modalPosition();
    },
    methods: {
        async getRealignments(cycle, departmentId){
            this.realigmentLoading = true;
            await this.$store
                .dispatch("realignmentrequest/GetRealignmentByDep", {cycle, departmentId})
                .then((res) => {
                    res.data.map((x) => {
                        x.viewItems = false;
                        x.realignmentItems = [];
                    });
                    this.realignments = res.data;
                    this.postedRealignments = res.data.filter((x) => x.status.toUpperCase() === "POSTED");
                    this.draftRealignment = res.data.find((x) => x.status.toUpperCase() === "DRAFT") ?? null;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            this.realigmentLoading = false;
        },
        getPostedRealignments(cycle, deliveryUnitId){
            this.$refs.postedModifications.getData(cycle, deliveryUnitId)
        },
        getApprovedRealignments(cycle, deliveryUnitId){
            this.$refs.tagApprovedRealignment.getData(cycle, deliveryUnitId)
        },
        getReturnedRealignments(cycle, deliveryUnitId){
            this.$refs.returnedModifications.getData(cycle, deliveryUnitId)
        },
        getPendingRealignment(cycle, departmentId){
            this.modificationNo = 0;
            this.$store
                .dispatch("realignmentrequestitem/GetPendingRealignmentItemByDep", {cycle, departmentId})
                .then((res) => {
                    res.data.map((x) => {
                        x.total = x.quantity * x.apiResourceDetail.apiResource.unitCost;
                        x.editQty = false;
                        x.fundSource = x.apiResourceDetail.apiResource.deliveryUnitBudgetItem.objectOfExpenditure.fundSource.sourceName;
                        x.accountGroup = x.apiResourceDetail.apiResource.deliveryUnitBudgetItem.objectOfExpenditure.accountGroup.groupName;
                    });
                    this.pendingRealignment = res.data;
                    this.modificationNo = res.data.length;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        modalPosition(){
            this.$nextTick(() => {
                setTimeout(() => {
                    var modal = this.$refs[`modification-modal`];
                    var btn = this.$refs[`myModificationBtn`];
                    var clientBtn = btn.getBoundingClientRect();
                    modal.style.top = `${clientBtn.top}px`;
                    modal.style.right = `calc(100% - ${clientBtn.right - 5}px)`;
                }, 500);
            });
        },
        async changeCycle(cycle) {
            this.getItemResources(cycle, this.$store.state.data.selectedDepartment.id);
            this.getPendingRealignment(cycle, this.$store.state.data.selectedDepartment.id)
            this.getRealignments(cycle, this.$store.state.data.selectedDepartment.id)
        },
        async changeDepartment(dep) {
            this.getItemResources(this.$store.state.data.cycle, dep.id);
            this.getPendingRealignment(this.$store.state.data.cycle, dep.id);
            this.getRealignments(this.$store.state.data.cycle, dep.id);
        },
        async getItemResources(cycle, departmentId) {
            this.tableData = [];
            this.tableBusy = true;
            await this.$store
                .dispatch("apiresource/GetAllResourceByDepartment", {
                    departmentId,
                    cycle
                })
                .then(async(res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let tableData = [];
                    res.data.sort((a, b) => b.statusReview - a.statusReview);
                    for (const x of res.data) {
                        x.filterKey = `${x.name} ${x.apiNumber}`;
                        x.resources = [];
                        await x.apiResources.map(item => {
                            item.statusReview = item.technicalReviewStatus.toUpperCase() === 'RETURNED' ? 1 : 0;
                            x.filterKey += ` ${item.itemName} ${item.description}`;
                            item.deliveryUnitBudgetItem.fundSource = item.deliveryUnitBudgetItem.objectOfExpenditure.fundSource.sourceName;
                            item.deliveryUnitBudgetItem.fundClass = item.deliveryUnitBudgetItem.objectOfExpenditure.accountGroup.fundClassification.classification;
                            item.deliveryUnitBudgetItem.accountGroup = item.deliveryUnitBudgetItem.objectOfExpenditure.accountGroup.groupName;
                            item.deliveryUnitBudgetItem.accountId = item.deliveryUnitBudgetItem.objectOfExpenditure.accountGroup.id;
                            item.thumbnailUrl = item.thumbnail
                                ? `${this.$store.state.data.rootFileDirectory}Procurement/${item.thumbnail}`
                                : "";
                            item.editQty = false;
                            item.remainingTotal = item.remainingQuantity * item.unitCost;
                            if(!item.mixParentId || item.mixParentId == 0){
                                item.kids = x.apiResources.filter(kid => kid.mixParentId == item.id);
                                item.filterKey = `${x.name} ${x.apiNumber} ${item.itemName} ${item.description}`;
                                x.resources.push(item);
                                for (const kid of item.kids) {
                                    kid.filterKey = `${x.name} ${x.apiNumber} ${item.itemName} ${item.description} ${kid.itemName} ${kid.description}`;
                                    x.resources.push(kid);
                                }
                            }
                            item.loadingAvailables = false;
                            item.unitCostWithInflation = item.totalInflation > 0 ? (item.unitCost + (item.unitCost * (item.totalInflation/100))) : item.unitCost;
                        })
                        delete x.apiResources;
                        tableData.push(x);
                    }
                    this.tableData = tableData;
                })
                .catch((err) => {
                    this.showToast("Something went wrong", "error");
                });
            this.tableBusy = false;
        },
        viewItemLogs({ id }) {
            this.$refs.itemlog.getData(id);
            this.$bvModal.show("api-resoure-log-modal");
        },
        notifyForUpdates(row){
            this.$store
                .dispatch("apiresource/TraceItem", {
                    id: row.id,
                    IsNotify: !row.notify,
                })
                .then((res) => {
                    this.showToast("Successfully set!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        deleteQty(row, month){
            this.totalReduceQty = this.totalReduceQty + row[`${month}Value`];
            this.reducedQty.push({apiResourceDetailId: row[`${month}Id`], quantity: row[`${month}Value`]});
            row[`${month}Value`] = (0).toString();
        },
        addQty(row, month){
            row[`${month}Value`] = (parseFloat(row[`${month}Value`]) + 1).toString();
            let index = this.reducedQty.findIndex(x => x.apiResourceDetailId == row[`${month}Id`]);
            this.reducedQty[index].quantity = this.reducedQty[index].quantity - 1;
            if(this.reducedQty[index].quantity == 0){
                this.reducedQty.splice(index, 1);
            }
            this.totalReduceQty--
        },
        reduceQty(row, month){
            row[`${month}Value`] = (parseFloat(row[`${month}Value`]) - 1).toString();
            if(this.reducedQty.findIndex(x => x.apiResourceDetailId == row[`${month}Id`]) == -1){
                this.reducedQty.push({apiResourceDetailId: row[`${month}Id`], quantity: 1});
            }else{
                let index = this.reducedQty.findIndex(x => x.apiResourceDetailId == row[`${month}Id`]);
                this.reducedQty[index].quantity = this.reducedQty[index].quantity + 1;
            }
            this.totalReduceQty++
        },
        async getAvailableForModifications(row){
            await this.$store
                .dispatch("realignmentrequestitem/GetAvailableRealignmentItem", row.id)
                .then((res) => {
                    row.availableResourceDetails = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async modifyItem(row){
            row.editQty = true;
            row.loadingAvailables = true;
            await this.getAvailableForModifications(row);
            row.loadingAvailables = false;
            this.tableData.map(x => {x.editQty = false})
            row.JanId = row.availableResourceDetails.find(x => x.monthId == 1)?.id || 0;
            row.JanMax = row.availableResourceDetails.find(x => x.monthId == 1)?.quantity || 0;
            row.JanValue = row.availableResourceDetails.find(x => x.monthId == 1) ? '0' : '';

            row.FebId = row.availableResourceDetails.find(x => x.monthId == 2)?.id || 0;
            row.FebMax = row.availableResourceDetails.find(x => x.monthId == 2)?.quantity || 0;
            row.FebValue = row.availableResourceDetails.find(x => x.monthId == 2) ? '0' : '';

            row.MarId = row.availableResourceDetails.find(x => x.monthId == 3)?.id || 0;
            row.MarMax= row.availableResourceDetails.find(x => x.monthId == 3)?.quantity || 0;
            row.MarValue = row.availableResourceDetails.find(x => x.monthId == 3) ? '0' : '';

            row.AprId = row.availableResourceDetails.find(x => x.monthId == 4)?.id || 0;
            row.AprMax = row.availableResourceDetails.find(x => x.monthId == 4)?.quantity || 0;
            row.AprValue = row.availableResourceDetails.find(x => x.monthId == 4) ? '0' : '';

            row.MayId = row.availableResourceDetails.find(x => x.monthId == 5)?.id || 0;
            row.MayMax = row.availableResourceDetails.find(x => x.monthId == 5)?.quantity || 0;
            row.MayValue = row.availableResourceDetails.find(x => x.monthId == 5) ? '0' : '';

            row.JunId = row.availableResourceDetails.find(x => x.monthId == 6)?.id || 0;
            row.JunMax = row.availableResourceDetails.find(x => x.monthId == 6)?.quantity || 0;
            row.JunValue = row.availableResourceDetails.find(x => x.monthId == 6) ? '0' : '';

            row.JulId = row.availableResourceDetails.find(x => x.monthId == 7)?.id || 0;
            row.JulMax = row.availableResourceDetails.find(x => x.monthId == 7)?.quantity || 0;
            row.JulValue = row.availableResourceDetails.find(x => x.monthId == 7) ? '0' : '';

            row.AugId = row.availableResourceDetails.find(x => x.monthId == 8)?.id || 0;
            row.AugMax = row.availableResourceDetails.find(x => x.monthId == 8)?.quantity || 0;
            row.AugValue = row.availableResourceDetails.find(x => x.monthId == 8) ? '0' : '';

            row.SepId = row.availableResourceDetails.find(x => x.monthId == 9)?.id || 0;
            row.SepMax = row.availableResourceDetails.find(x => x.monthId == 9)?.quantity || 0;
            row.SepValue = row.availableResourceDetails.find(x => x.monthId == 9) ? '0' : '';

            row.OctId = row.availableResourceDetails.find(x => x.monthId == 10)?.id || 0;
            row.OctMax = row.availableResourceDetails.find(x => x.monthId == 10)?.quantity || 0;
            row.OctValue = row.availableResourceDetails.find(x => x.monthId == 10) ? '0' : '';

            row.NovId = row.availableResourceDetails.find(x => x.monthId == 11)?.id || 0;
            row.NovMax = row.availableResourceDetails.find(x => x.monthId == 11)?.quantity || 0;
            row.NovValue = row.availableResourceDetails.find(x => x.monthId == 11) ? '0' : '';

            row.DecId = row.availableResourceDetails.find(x => x.monthId == 12)?.id || 0;
            row.DecMax = row.availableResourceDetails.find(x => x.monthId == 12)?.quantity || 0;
            row.DecValue = row.availableResourceDetails.find(x => x.monthId == 12) ? '0' : '';

            this.reducedQty = [];
            this.totalReduceQty = 0;
        },
        updateProfile(row) {
            this.resourceIndex = this.tableData.indexOf(row);
            this.profileTobeUpdated = row;
            this.modalTitle = "Update Profile";
            this.$bvModal.show("upload-profile");
            this.$refs.profileCropper.resetData();
            if (row.image) {
                this.$refs.profileCropper.updateProfile = true;
                this.$refs.profileCropper.imageUrl = `${this.$store.state.data.rootFileDirectory}Procurement/${row.image}`;
                this.$refs.profileCropper.showCropBtn = true;
            }else{
                this.$refs.profileCropper.updateProfile = false;
                this.$refs.profileCropper.imageUrl = "";
            }
        },
        async cropData(event) {
            let updateProfile = await this.updateApiResourceImg(event, this.profileTobeUpdated);
            if(updateProfile.success){
                this.tableData[this.resourceIndex].image = updateProfile.data.image;
                this.tableData[this.resourceIndex].thumbnail = updateProfile.data.thumbnail;
                this.tableData[
                    this.resourceIndex
                ].thumbnailUrl = `${this.$store.state.data.rootFileDirectory}Procurement/${updateProfile.data.thumbnail}`;
                this.$bvModal.hide("upload-profile");
                this.showToast("Successfully uploaded!", "success");
            }else{
                this.showToast(updateProfile.data, "error");
            }
        },
        resubmitItem(x) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to resubmit this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, resubmit it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("apiresource/ResubmitPPMPItem", x.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            x.technicalReviewStatus = "PENDING";
                            this.showToast("Successfully resubmitted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        async modificationAnimation(row){
            this.runAnimation = true;
            var button = this.$refs[`modification-btn-${row.id}`][0];
            var squareDiv = this.$refs[`square-div`];
            var clientBtn = button.getBoundingClientRect();
            const div = document.createElement('div');
            div.className = 'square-spinner bx bx-paper-plane';
            div.style.top = `${clientBtn.top}px`;
            div.style.left = `${clientBtn.right - 8}px`;
            div.setAttribute('id', `spinner-${row.id}`);
            squareDiv.appendChild(div);
            var outBtn = this.$refs[`myModificationBtn`];
            var outClient = outBtn.getBoundingClientRect();
            await this.wait(50);
            div.style.top = `${outClient.top + 8}px`;
            div.style.left = `${outClient.right - 15}px`;
            await this.wait(500);
            this.runAnimation = false;
            this.modificationNo++;
            squareDiv.removeChild(div);
        },
        async addToModification(row){
            Swal.fire({
                title: "Are you sure?",
                text: "You want to add this to modification?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, add this!",
            }).then(async (result) => {
                if(result.value){
                    var error = 0;
                    this.pageLoader(true);
                    var endpoint = '';
                    var endpointData = {}
                    if(!this.draftRealignment){
                        endpoint = 'realignmentrequestitem/CreateRealignment';
                        endpointData = {
                            deliveryUnitId: this.$store.state.data.selectedDU.id,
                            cycle: this.$store.state.data.cycle,
                            apiResourceDetailId: 0,
                            quantity: 0,
                        }
                    }else{
                        endpoint = 'realignmentrequestitem/AddRealignment';
                        endpointData = {
                            realignmentRequestItemId: this.draftRealignment.id,
                            apiResourceDetailId: 0,
                            quantity: 0,
                        }
                    }
                    for await(const item of this.reducedQty){
                        if(item.quantity == 0){
                            continue;
                        }
                        endpointData.apiResourceDetailId = item.apiResourceDetailId;
                        endpointData.quantity = item.quantity;
                        await this.$store
                            .dispatch(endpoint, endpointData)
                            .then(async (res) => {
                                if (res.data.error) {
                                    error++;
                                }else{
                                    this.pendingRealignment.push({
                                        id: res.data.id,
                                        apiResourceDetailId: item.apiResourceDetailId,
                                        quantity: item.quantity,
                                        apiResourceDetail: {
                                            id: item.apiResourceDetailId,
                                            apiResourceId: row.id,
                                            apiResource: {
                                                apiId: row.apiId,
                                                id: row.id,
                                                description: row.description,
                                                itemName: row.itemName,
                                                unitCost: row.unitCost,
                                            },
                                            monthId: row.availableResourceDetails.find(x => x.id == item.apiResourceDetailId).monthId,
                                            month: row.availableResourceDetails.find(x => x.id == item.apiResourceDetailId).month
                                        },
                                        total: item.quantity * row.unitCost,
                                        realignmentRequestId: null,
                                        editQty: false,
                                        fundSource: row.deliveryUnitBudgetItem.objectOfExpenditure.fundSource.sourceName,
                                        accountGroup: row.deliveryUnitBudgetItem.objectOfExpenditure.accountGroup.groupName,
                                    })
                                    this.modificationAnimation(row);
                                    let total = parseFloat(item.quantity) * parseFloat(row.unitCost);
                                    row.availableResourceDetails.find(x => x.id == item.apiResourceDetailId).quantity -= item.quantity;
                                    row.remainingTotal -= total;
                                }
                            })
                            .catch((err) => {
                                error++;
                            });
                    }
                    if(error == 0){
                        row.editQty = false;
                        row.remainingQuantity = row.remainingQuantity - this.reducedQty.reduce((a, b) => a + b.quantity, 0);
                        this.showToast("Successfully added to modification!", "success");
                    }else{
                        this.showToast("Something went wrong!", "error");
                    }
                    this.pageLoader(false);
                }
            });
        },
        async modalAnimation(){
            var modal = this.$refs[`modification-modal`];
            modal.style.zIndex = '1200';
            modal.style.right = '50px';
            modal.style.top = '50px';
            await this.wait(150);
            document.getElementsByTagName('body')[0].classList.add('public-post-open');
            modal.style.backgroundColor = '#2a3042';
            modal.style.minHeight = 'calc(100% - 100px)';
            modal.style.minWidth = 'calc(100% - 100px)';
            await this.wait(250);
            this.openModificationModal = true;
            await this.wait(250);
            let header = this.$refs[`modal-modification-header`];
            let body = this.$refs[`modal-modification-body`];
            body.style.maxHeight = `calc(100vh - ${header.clientHeight + 100}px)`;
            body.style.overflowY = `auto`;
        },
        showMyModification(){
            this.modalAnimation();
            this.modalTitle = 'My Modifications';
            this.wait(1500).then(() => {
                if(this.draftRealignment){
                    this.$refs.pendingModifications.getProposedModifications(this.draftRealignment.id);
                }
            })
        },
        closeModification(){
            document.getElementsByTagName('body')[0].classList.remove('public-post-open');
            this.openModificationModal = false;
            var modal = this.$refs[`modification-modal`];
            var btn = this.$refs[`myModificationBtn`];
            var clientBtn = btn.getBoundingClientRect();
            modal.style.minHeight = '10px';
            modal.style.minWidth = '10px';
            modal.style.right = '50px';
            modal.style.top = '50px';
            setTimeout(() => {
                modal.style.backgroundColor = '#2a3042';
                modal.style.top = `${clientBtn.top}px`;
                modal.style.right = `calc(100% - ${clientBtn.right - 5}px)`;
                modal.style.zIndex = '-1';
            }, 250);
        },
        async updateResourceItem(props, type = "edit") {
            this.pageLoader(true);
            this.selectedApiId = props.apiId;
            await this.$refs['resource-update'].getAllBudgets(props.apiId);
            await this.$refs['resource-update'].getItemInfo(props, type);
            this.pageLoader(false);
        },
        updateAlignmentItem(row){
            // let diff = parseFloat(row.maxValue) - parseFloat(row.monthValue);
            // let parentIndex = this.tableData.findIndex((e) => e.id == row.apiResourceDetail.apiResource.apiId);
            // let apiResource = this.tableData[parentIndex].apiResources.find((e) => e.id == row.apiResourceDetail.apiResourceId);
            // if(apiResource){
            //     apiResource.availableResourceDetails.find((e) => e.id == row.apiResourceDetailId).quantity += diff;
            //     apiResource.remainingQuantity += diff;
            //     apiResource.remainingTotal += (diff * row.apiResourceDetail.apiResource.unitCost);
            // }
        },
        deleteAllItems(){
            this.pendingRealignment = [];
            this.modificationNo = 0;
        },
        deleteAlignmentItem(id){
            var index = this.pendingRealignment.findIndex((e) => e.id == id);
            // let realignment = this.pendingRealignment[index];
            // let parentIndex = this.tableData.findIndex((e) => e.id == realignment.apiResourceDetail.apiResource.apiId);
            // let apiResource = this.tableData[parentIndex].resources.find((e) => e.id == realignment.apiResourceDetail.apiResourceId);
            // if(apiResource){
            //     apiResource.availableResourceDetails.find((e) => e.id == realignment.apiResourceDetailId).quantity += realignment.quantity;
            //     apiResource.remainingQuantity += parseFloat(realignment.quantity);
            //     apiResource.remainingTotal += parseFloat(realignment.total);
            // }
            this.pendingRealignment.splice(index, 1);
            this.modificationNo--;
            this.showToast("Successfully removed!", "success");
        },
        createRealignment(data){
            this.draftRealignment = data;
        },
        removeRealignment(){
            this.pendingRealignment = [];
            this.draftRealignment = null;
            this.modificationNo = 0;
        },
        postRealignment(){
            this.draftRealignment.status = 'POSTED';
            this.draftRealignment.viewItems = false;
            this.draftRealignment.realignmentItems = [];
            this.postedRealignments.push(this.draftRealignment);
            this.pendingRealignment = [];
            this.draftRealignment = null;
            this.modificationNo = 0;
        },
        tagPostRealignment(){
            this.$refs.postedModifications.tableData = this.postedRealignments;
        },
        printRealignment(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Finance/Realignment",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        closeUpdateModal(data){
            let apiIndex = this.tableData.findIndex(x => x.id == this.selectedApiId);
            let index = this.tableData[apiIndex].apiResources.findIndex(x => x.id == data.id);
            this.tableData[apiIndex].apiResources[index].totalQuantity = data.quantity;
            this.tableData[apiIndex].apiResources[index].totalWithInflation = data.amount;
        },
        successUpdateResource(data){
            let apiIndex = this.tableData.findIndex(x => x.id == this.selectedApiId);
            let index = this.tableData[apiIndex].apiResources.findIndex(x => x.id == data.id);
            this.tableData[apiIndex].apiResources.splice(index, 1, data);
        },
        updateItemColumn(data){
            let index = this.tableData.findIndex(x => x.id == this.selectedApiId);
            let api = this.tableData[index];
            if(data.type === 'deduct'){
                api.apiResources.find((e) => e.id == data.id)[data.column] -= data.value;
            }else if(data.type === 'add'){
                api.apiResources.find((e) => e.id == data.id)[data.column] += data.value;
            }else{
                api.apiResources.find((e) => e.id == data.id)[data.column] = data.value;
            }
        },
        deleteResourceItem(props) {
            var apiIndex = this.tableData.findIndex(x => x.id == props.apiId);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("apiresource/DeletePPMPItem", props.id)
                        .then((res) => {
                            if (res.status == 204) {
                                let index = this.tableData[apiIndex].apiResources.findIndex(x => x.id == props.id);
                                this.tableData[apiIndex].apiResources.splice(index, 1);
                                if(props.mixParentId > 0){
                                    this.tableData[apiIndex].apiResources.find((e) => e.id === props.mixParentId).remaining += props.totalWithInflation;
                                }
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        inputHandler(event, row, month){
            const value = event.target.value + '' + event.key;
            if(parseFloat(value) > parseFloat(row[`${month}Max`])){
                event.preventDefault();
            }
        },
        changeItemValue(row){
            let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            let sum = 0;
            this.reducedQty = [];
            months.forEach((e) => {
                sum += row[`${e}Value`] ? parseFloat(row[`${e}Value`]) : 0;
                if(row[`${e}Value`]){
                    this.reducedQty.push({apiResourceDetailId: row[`${e}Id`], quantity: row[`${e}Value`]});   
                }
            });
            this.totalReduceQty = sum;
        },
        filterResources(row){
            let data = row;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data;
        },
        viewModifItems(items){
            this.$bvModal.show("modif-items-modal");
            this.$refs.viewItems.setItems(items);
        },
        showModifyBtn(row){
            if(!row.isMixed) return true;
            if(row.isMixed && !row.kids.length) return true;
            return false;
        },
        viewLogs(realignmentId){
            this.$bvModal.show('realigment-remarks-modal')
            this.$refs.realignmentRemarks.getData(realignmentId);
        },
    }

}
</script>
<template>
    <Layout @changeCycle="changeCycle" @changeDepartment="changeDepartment">
        <PageHeader :title="title" :items="items" />
        <ResourceUpdate 
            ref="resource-update" 
            :budgetTransferModal="false"
            :updatableMixOption="false"
            @close-update="closeUpdateModal" 
            @update-item="successUpdateResource" 
            @specific-item-update="updateItemColumn"
            @refresh-all="getItemResources(this.$store.state.data.cycle, this.$store.state.data.selectedDepartment.id)"
        />
        <div>
            <div class="mb-2">
                <div class="d-flex align-items-center justify-content-between">
                    <label
                        class="d-inline-flex align-items-center mb-0 me-1"
                    >
                        <b-form-input
                            autocomplete="off"
                            v-model="filter"
                            type="search"
                            placeholder="Search Item Resources..."
                            class="form-control"
                            style="width: 300px;"
                        ></b-form-input>
                        <b-form-select
                            class="form-select ms-1 w-25"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                    </label>
                    <button type="button" class="btn btn-success" ref="myModificationBtn" @click="showMyModification"><i class="bx bx-bookmark-minus me-1"></i>My Modification<span class="badge bg-danger" v-if="modificationNo > 0">{{modificationNo}}</span></button>
                </div>
            </div>
            <div class="table-responsive">
                <table
                    class="
                        table
                        project-list-table
                        table-centered
                        table-borderless
                        align-middle
                        resource-item-table
                    "
                >
                    <thead>
                        <tr>
                            <th width="30px"></th>
                            <th width="20px"></th>
                            <th scope="col">
                                Item Name
                            </th>
                            <th scope="col">
                                Description
                            </th>
                            <th
                                scope="col"
                                width="150px"
                                class="
                                    text-center
                                "
                            >
                                Quantity
                            </th>
                            <th
                                scope="col"
                                width="150px"
                            >
                                Unit Cost
                            </th>
                            <th
                                scope="col"
                                width="150px"
                            >
                                Total
                            </th>
                            <th
                                scope="col"
                                width="100px"
                                class="
                                    text-center
                                "
                            >
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="tableBusy">
                            <td colspan="8">
                                <div class="d-flex justify-content-center align-items-center">
                                    <div class="preloader-component me-2">
                                        <div class="status">
                                            <div class="spinner-chase w-20px h-20px">
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <strong>Loading...</strong>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="tableData.length == 0 && !tableBusy">
                            <td colspan="8" class="text-muted text-center">
                                <i class="dripicons-warning me-1"></i>No data found
                            </td>
                        </tr>
                        <tr v-if="tableData.length > 0 && !tableBusy && filtered.length == 0">
                            <td colspan="8" class="text-muted text-center">
                                <i class="dripicons-warning me-1"></i>Search not found
                            </td>
                        </tr>
                        <template v-for="y in filtered">
                            <tr :key="y.id" style="background-color: transparent; box-shadow: none;">
                                <td colspan="8" class="position-relative">
                                    <RawData 
                                        :data="{id: y.id, apiNumber: y.apiNumber, name: y.name, description: y.description, totalResources: y.totalResources}" 
                                        v-if="$store.state.decrypt.isAdmin()" 
                                        placement="left"
                                    />
                                    <span class="text-warning">{{y.apiNumber}}</span> - {{y.name}}
                                </td>
                            </tr>
                            <template v-for="x in filterResources(y.resources)">
                                <tr
                                    :key="`A${y.id}B${x.id}`"
                                    :ref="`resource-tr-${x.id}`"
                                    style="background-color: transparent; box-shadow: none;"
                                >
                                    <td></td>
                                    <td v-if="x.mixParentId > 0"><i class="bx bx-right-arrow-alt"></i></td>
                                    <td
                                        :colspan="(x.mixParentId == 0 || !x.mixParentId) ? 2 : 1"
                                        class="
                                            border
                                            border-end-0
                                            bg-table-tr
                                            position-relative
                                        "
                                        :class="{
                                            'border-success':
                                                x.technicalReviewStatus
                                                    .toUpperCase()
                                                    .includes(
                                                        'APPROVED'
                                                    ),
                                            'border-warning':
                                                x.technicalReviewStatus
                                                    .toUpperCase()
                                                    .includes(
                                                        'RETURN'
                                                    ),
                                        }"
                                    >
                                        <RawData 
                                            :data="x" 
                                            v-if="$store.state.decrypt.isAdmin()" 
                                            placement="left"
                                            :keyId="`A${y.id}B${x.id}`"
                                        />
                                        <div class="d-flex align-items-center">
                                            <div class="me-2">
                                                <div 
                                                    style="height: 50px; width: 50px;"
                                                    class="bg-secondary cursor-pointer"
                                                    @click="updateProfile(x)"
                                                >
                                                    <img
                                                        :src=" x.thumbnailUrl"
                                                        v-if="x.thumbnail"
                                                        class="img-fluid"
                                                        style="height: 50px; width: 50px;"
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <div>{{ x.itemName }}</div>
                                                <div class="mb-1">
                                                    <small>
                                                        <i>{{x.itemCategory.name}}</i>
                                                        <span class="text-warning ms-1">[{{x.isProcurable ? 'Procurable' : 'Non-procurable' }}]</span>
                                                        <span class="text-warning ms-1" v-if="x.isMixed">[Mixed]</span>
                                                        <span class="ms-1">{{x.itemCategory.itemCategoryGroup.technicalReviewUsers.length > 0 ? `[${x.itemCategory.itemCategoryGroup.technicalReviewUsers[0].applicationUser.completeName.trim()}]` : ''}}</span>
                                                    </small>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <span class="badge bg-secondary text-white py-1 px-2 me-2">
                                                        {{x.deliveryUnitBudgetItem.fundSource}}
                                                    </span>
                                                    <span class="badge bg-purple text-white me-2 py-1 px-2">
                                                        {{x.deliveryUnitBudgetItem.fundClass}}
                                                    </span>
                                                    <span class="badge bg-success text-white py-1 px-2 me-2">
                                                        {{ x.deliveryUnitBudgetItem.accountGroup}}
                                                    </span>
                                                </div>
                                                <div class="mt-2">
                                                    <div class="form-check form-checkbox-outline form-check-success mb-0">
                                                        <input
                                                            autocomplete="off"
                                                            class="form-check-input"
                                                            type="checkbox"
                                                            :id="`notify-${x.id}`"
                                                            v-model="x.notify"
                                                            @click="notifyForUpdates(x)"
                                                        />&nbsp;&nbsp;
                                                        <label
                                                            class="form-check-label"
                                                            :for="`notify-${x.id}`"
                                                            >Notify for Item Updates</label
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td
                                        class="
                                            border
                                            border-start-0
                                            border-end-0
                                            bg-table-tr
                                        "
                                        :class="{
                                            'border-success':
                                                x.technicalReviewStatus
                                                    .toUpperCase()
                                                    .includes('APPROVED'),
                                            'border-warning':
                                                x.technicalReviewStatus
                                                    .toUpperCase()
                                                    .includes('RETURN'),
                                        }"
                                    >
                                        {{ x.description }}
                                    </td>
                                    <td
                                        class="
                                            border
                                            border-start-0
                                            border-end-0
                                            text-center
                                            bg-table-tr
                                        "
                                        :class="{
                                            'border-success':
                                                x.technicalReviewStatus
                                                    .toUpperCase()
                                                    .includes('APPROVED'),
                                            'border-warning':
                                                x.technicalReviewStatus
                                                    .toUpperCase()
                                                    .includes('RETURN'),
                                        }"
                                        
                                    >
                                        <span :id="`editQ-${x.id}`" class="px-2">{{
                                            x.remainingQuantity == 0 ? '-' : numberWithCommas(x.remainingQuantity)
                                        }}</span>
                                        <b-popover
                                            :show.sync="x.editQty"
                                            :target="`editQ-${x.id}`"
                                            custom-class="item-resource"
                                            triggers="click"
                                            placement="left"
                                        >
                                            <template v-slot:title>
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <small>Item Resource Details</small>
                                                    <span 
                                                        class="bx bx-x font-size-14 cursor-pointer"
                                                        @click="x.editQty = false"
                                                    ></span>
                                                </div>
                                            </template>
                                            <div class="position-relative">
                                                <div class="position-absolute d-flex align-items-center justify-content-center loading-po" v-if="x.loadingAvailables">
                                                    <div
                                                        class="spinner-border text-primary spinner-border-sm"
                                                        role="status"
                                                    >
                                                        <span class="visually-hidden">
                                                            Loading...
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="text-center mb-3">
                                                    <h6>Available Quantity for Modifications</h6>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label for="Jan" class="mb-0">January <span v-if="x.JanMax > 0" class="text-warning">(Max: {{x.JanMax}})</span></label>
                                                        <b-input-group>
                                                            <masked-input 
                                                                :mask="currencyMask" 
                                                                type="text" 
                                                                class="form-control form-control-sm text-center"  
                                                                v-if="x.JanMax > 0" 
                                                                v-model="x.JanValue"
                                                                @keypress="inputHandler($event, x, 'Jan')"
                                                                @keyup="changeItemValue(x)"
                                                            ></masked-input>
                                                            <div class="form-control form-control-sm text-center" v-else>{{x.JanValue}}</div>
                                                        </b-input-group>
                                                        <div class="text-center" :class="{'po-fs': x.JanMax == 0 || x.JanMax != x.JanValue}">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label for="Feb" class="mb-0">February <span v-if="x.FebMax > 0" class="text-warning">(Max: {{x.FebMax}})</span></label>
                                                        <b-input-group>
                                                            <masked-input 
                                                                :mask="currencyMask" 
                                                                type="text" 
                                                                class="form-control form-control-sm text-center"
                                                                v-if="x.FebMax > 0" 
                                                                v-model="x.FebValue"
                                                                @keypress="inputHandler($event, x, 'Feb')"
                                                                @keyup="changeItemValue(x)"
                                                            >
                                                            </masked-input>
                                                            <div class="form-control form-control-sm text-center" v-else>{{x.FebValue}}</div>
                                                        </b-input-group>
                                                        <div class="text-center" :class="{'po-fs': x.FebMax == 0 || x.FebValue != x.FebMax}">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label for="Mar" class="mb-0">March <span v-if="x.MarMax > 0" class="text-warning">(Max: {{x.MarMax}})</span></label>
                                                        <b-input-group>
                                                            <masked-input 
                                                                :mask="currencyMask" 
                                                                type="text" 
                                                                class="form-control form-control-sm text-center" 
                                                                v-if="x.MarMax > 0" 
                                                                v-model="x.MarValue"
                                                                @keypress="inputHandler($event, x, 'Mar')"
                                                                @keyup="changeItemValue(x)"
                                                            ></masked-input>
                                                            <div class="form-control form-control-sm text-center" v-else>{{x.MarValue}}</div>
                                                        </b-input-group>
                                                        <div class="text-center" :class="{'po-fs': x.MarMax == 0 || x.MarValue != x.MarMax}">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label for="Apr" class="mb-0">April <span v-if="x.AprMax > 0" class="text-warning">(Max: {{x.AprMax}})</span></label>
                                                        <b-input-group>
                                                            <masked-input 
                                                                :mask="currencyMask" 
                                                                type="text" 
                                                                class="form-control form-control-sm text-center"  
                                                                v-if="x.AprMax > 0" 
                                                                v-model="x.AprValue"
                                                                @keypress="inputHandler($event, x, 'Apr')"
                                                                @keyup="changeItemValue(x)"
                                                            ></masked-input>
                                                            <div class="form-control form-control-sm text-center" v-else>{{x.AprValue}}</div>
                                                        </b-input-group>
                                                        <div class="text-center" :class="{'po-fs': x.AprMax == 0 || x.AprValue != x.AprMax}">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label for="May" class="mb-0">May <span v-if="x.MayMax > 0" class="text-warning">(Max: {{x.MayMax}})</span></label>
                                                        <b-input-group>
                                                            <masked-input 
                                                                :mask="currencyMask" 
                                                                type="text" 
                                                                class="form-control form-control-sm text-center" 
                                                                v-if="x.MayMax > 0" 
                                                                v-model="x.MayValue"
                                                                @keypress="inputHandler($event, x, 'May')"
                                                                @keyup="changeItemValue(x)"
                                                            ></masked-input>
                                                            <div class="form-control form-control-sm text-center" v-else>{{x.MayValue}}</div>
                                                        </b-input-group>
                                                        <div class="text-center" :class="{'po-fs': x.MayMax == 0 || x.MayValue != x.MayMax}">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label for="Jun" class="mb-0">June <span v-if="x.JunMax > 0" class="text-warning">(Max: {{x.JunMax}})</span></label>
                                                        <b-input-group>
                                                            <masked-input 
                                                                :mask="currencyMask" 
                                                                type="text" 
                                                                class="form-control form-control-sm text-center" 
                                                                v-if="x.JunMax > 0" 
                                                                v-model="x.JunValue"
                                                                @keypress="inputHandler($event, x, 'Jun')"
                                                                @keyup="changeItemValue(x)"
                                                            ></masked-input>
                                                            <div class="form-control form-control-sm text-center" v-else>{{x.JunValue}}</div>
                                                        </b-input-group>
                                                        <div class="text-center" :class="{'po-fs': x.JunMax == 0 || x.JunValue != x.JunMax}">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label for="Jul" class="mb-0">July <span v-if="x.JulMax > 0" class="text-warning">(Max: {{x.JulMax}})</span></label>
                                                        <b-input-group>
                                                            <masked-input 
                                                                :mask="currencyMask" 
                                                                type="text" 
                                                                class="form-control form-control-sm text-center" 
                                                                v-if="x.JulMax > 0" 
                                                                v-model="x.JulValue"
                                                                @keypress="inputHandler($event, x, 'Jul')"
                                                                @keyup="changeItemValue(x)"
                                                            ></masked-input>
                                                            <div class="form-control form-control-sm text-center" v-else>{{x.JulValue}}</div>
                                                        </b-input-group>
                                                        <div class="text-center" :class="{'po-fs': x.JulMax == 0 || x.JulValue != x.JulMax}">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label for="Aug" class="mb-0">August <span v-if="x.AugMax > 0" class="text-warning">(Max: {{x.AugMax}})</span></label>
                                                        <b-input-group>
                                                            <masked-input 
                                                                :mask="currencyMask" 
                                                                type="text" class="form-control form-control-sm text-center" 
                                                                v-if="x.AugMax > 0" 
                                                                v-model="x.AugValue"
                                                                @keypress="inputHandler($event, x, 'Aug')"
                                                                @keyup="changeItemValue(x)"
                                                            ></masked-input>
                                                            <div class="form-control form-control-sm text-center" v-else>{{x.AugValue}}</div>
                                                        </b-input-group>
                                                        <div class="text-center" :class="{'po-fs': x.AugMax == 0 || x.AugValue != x.AugMax}">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label for="Sep" class="mb-0">September <span v-if="x.SepMax > 0" class="text-warning">(Max: {{x.SepMax}})</span></label>
                                                        <b-input-group>
                                                            <masked-input 
                                                                :mask="currencyMask" 
                                                                type="text" 
                                                                class="form-control form-control-sm text-center" 
                                                                v-if="x.SepMax > 0" 
                                                                v-model="x.SepValue"
                                                                @keypress="inputHandler($event, x, 'Sep')"
                                                                @keyup="changeItemValue(x)"
                                                            ></masked-input>
                                                            <div class="form-control form-control-sm text-center" v-else>{{x.SepValue}}</div>
                                                        </b-input-group>
                                                        <div class="text-center" :class="{'po-fs': x.SepMax == 0 || x.SepValue != x.SepMax}">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label for="Oct" class="mb-0">October <span v-if="x.OctMax > 0" class="text-warning">(Max: {{x.OctMax}})</span></label>
                                                        <b-input-group>
                                                            <masked-input 
                                                                :mask="currencyMask" 
                                                                type="text" 
                                                                class="form-control form-control-sm text-center" 
                                                                v-if="x.OctMax > 0" v-model="x.OctValue"
                                                                @keypress="inputHandler($event, x, 'Oct')"
                                                                @keyup="changeItemValue(x)"
                                                            ></masked-input>
                                                            <div class="form-control form-control-sm text-center" v-else>{{x.OctValue}}</div>
                                                        </b-input-group>
                                                        <div class="text-center"  :class="{'po-fs': x.OctMax == 0 || x.OctValue != x.OctMax}">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label for="Nov" class="mb-0">November <span v-if="x.NovMax > 0" class="text-warning">(Max: {{x.NovMax}})</span></label>
                                                        <b-input-group>
                                                            <masked-input 
                                                                :mask="currencyMask" 
                                                                type="text" 
                                                                class="form-control form-control-sm text-center" 
                                                                v-if="x.NovMax > 0" 
                                                                v-model="x.NovValue"
                                                                @keypress="inputHandler($event, x, 'Nov')"
                                                                @keyup="changeItemValue(x)"
                                                            ></masked-input>
                                                            <div class="form-control form-control-sm text-center" v-else>{{x.NovValue}}</div>
                                                        </b-input-group>
                                                        <div class="text-center" :class="{'po-fs': x.NovMax == 0 || x.NovValue != x.NovMax}">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label for="Dec" class="mb-0">December <span v-if="x.DecMax > 0" class="text-warning">(Max: {{x.DecMax}})</span></label>
                                                        <b-input-group>
                                                            <masked-input 
                                                                :mask="currencyMask" 
                                                                type="text" 
                                                                class="form-control form-control-sm text-center" 
                                                                v-if="x.DecMax > 0" 
                                                                v-model="x.DecValue"
                                                                @keypress="inputHandler($event, x, 'Dec')"
                                                                @keyup="changeItemValue(x)"
                                                            ></masked-input>
                                                            <div class="form-control form-control-sm text-center" v-else>{{x.DecValue}}</div>
                                                        </b-input-group>
                                                        <div class="text-center" :class="{'po-fs': x.DecMax == 0 || x.DecValue != x.DecMax}">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="mt-2">
                                                    <span class="d-block">Alignment Qty: <span class="text-warning">{{totalReduceQty}}</span></span>
                                                    <span>Alignment Cost: <span class="text-warning">{{formatCurrency(totalReduceQty * x.unitCost)}}</span></span>
                                                </div>
                                                <div
                                                    class="
                                                        text-right
                                                        mt-2
                                                    "
                                                >
                                                    <button
                                                        type="button"
                                                        class="
                                                            btn
                                                            btn-success
                                                            btn-sm
                                                            me-2
                                                        "
                                                        v-if="totalReduceQty > 0"
                                                        :ref="`modification-btn-${x.id}`"
                                                        @click="
                                                            addToModification(x)
                                                        "
                                                        :disabled="runAnimation"
                                                    >
                                                        Add to Modification
                                                    </button>
                                                    <button
                                                        type="button"
                                                        class="
                                                            btn
                                                            btn-link
                                                            btn-sm
                                                        "
                                                        @click="
                                                        x.editQty = false
                                                        "
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        </b-popover>
                                    </td>
                                    <td
                                        class="
                                            border
                                            border-start-0
                                            border-end-0
                                            bg-table-tr
                                        "
                                        :class="{
                                            'border-success':
                                                x.technicalReviewStatus
                                                    .toUpperCase()
                                                    .includes(
                                                        'APPROVED'
                                                    ),
                                            'border-warning':
                                                x.technicalReviewStatus
                                                    .toUpperCase()
                                                    .includes(
                                                        'RETURN'
                                                    ),
                                        }"
                                    >
                                        {{
                                            formatCurrency(x.unitCostWithInflation)
                                        }}
                                    </td>
                                    <td
                                        class="
                                            border
                                            border-start-0
                                            border-end-0
                                            bg-table-tr
                                        "
                                        :class="{
                                            'border-success':
                                                x.technicalReviewStatus
                                                    .toUpperCase()
                                                    .includes(
                                                        'APPROVED'
                                                    ),
                                            'border-warning':
                                                x.technicalReviewStatus
                                                    .toUpperCase()
                                                    .includes(
                                                        'RETURN'
                                                    ),
                                        }"
                                    >
                                        {{
                                            x.remainingQuantity == 0 ? '-' : formatCurrency(x.remainingQuantity * x.unitCostWithInflation)
                                        }}
                                        <div v-if="x.totalInflation > 0">
                                            <small>Inflation: {{formatCurrency(x.totalInflation)}}</small>
                                        </div>
                                        <div v-if="x.isMixed">
                                            <small class="text-warning">Mixed Amt. Remaining:</small>
                                            <div style="line-height:12px;">
                                                <small class="text-warning">{{formatCurrency(x.remaining)}}</small>
                                            </div>
                                        </div>
                                    </td>
                                    <td
                                        :class="{
                                            'border-success':
                                                x.technicalReviewStatus
                                                    .toUpperCase()
                                                    .includes(
                                                        'APPROVED'
                                                    ),
                                            'border-warning':
                                                x.technicalReviewStatus
                                                    .toUpperCase()
                                                    .includes(
                                                        'RETURN'
                                                    ),
                                        }"
                                        class="
                                            text-center
                                            border
                                            border-start-0
                                            bg-table-tr
                                        "
                                    >
                                        <b-dropdown
                                            class="
                                                card-drop
                                            "
                                            menu-class="dropdown-menu-end"
                                            variant="white"
                                            toggle-class="p-0"
                                        >
                                            <template
                                                v-slot:button-content
                                            >
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-dots-horizontal
                                                        font-size-18
                                                    "
                                                ></i>
                                            </template>
                                            <b-dropdown-item
                                                @click="
                                                    resubmitItem(
                                                        x
                                                    )
                                                "
                                                variant="success"
                                                v-if="x.technicalReviewStatus.toUpperCase().includes('RETURN') && !x.isMixed"
                                                ><i
                                                    class="
                                                        bx
                                                        bx-check
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Resubmit
                                                Item</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                @click="
                                                    modifyItem(
                                                        x
                                                    )
                                                "
                                                v-if="showModifyBtn(x)"
                                                ><i
                                                    class="
                                                        bx bx-bookmark-minus
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Modify Item</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                @click="
                                                    viewItemLogs(
                                                        x
                                                    )
                                                "
                                                variant="dark"
                                                ><i
                                                    class="
                                                        bx
                                                        bx-menu-alt-right
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >View
                                                Logs</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                @click="
                                                    updateResourceItem(
                                                        x
                                                    )
                                                "
                                                v-if="x.technicalReviewStatus.toUpperCase().includes('RETURN') && !x.isMixed && $store.state.decrypt.isAdmin()"
                                                variant="dark"
                                                ><i
                                                    class="
                                                        bx
                                                        bx-edit
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Edit</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                @click="
                                                    updateResourceItem(
                                                        x,
                                                        'view'
                                                    )
                                                "
                                                variant="dark"
                                                ><i
                                                    class="
                                                        bx
                                                        bx-food-menu
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >View
                                                Details</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                v-if="
                                                    x.isMixed &&
                                                    (selectedTransfer && !selectedTransfer.id)
                                                "
                                                @click="
                                                    createMixItem(
                                                        x
                                                    )
                                                "
                                                variant="primary"
                                                ><i
                                                    class="
                                                        bx
                                                        bx-plus
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Create Item</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                v-if="x.technicalReviewStatus.toUpperCase().includes('RETURN') && !x.isMixed && $store.state.decrypt.isAdmin()"
                                                @click="
                                                    deleteResourceItem(
                                                        x
                                                    )
                                                "
                                                variant="danger"
                                                
                                                ><i
                                                    class="
                                                        mdi
                                                        mdi-trash-can
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Delete </b-dropdown-item
                                            >
                                        </b-dropdown>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
            <div class="row my-3">
                <div class="col">
                    <div
                        class="
                            dataTables_paginate
                            paging_simple_numbers
                            float-end
                        "
                    >
                        <ul
                            class="
                                pagination pagination-rounded
                                mb-0
                            "
                        >
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage"
                            ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div ref="square-div"></div>
        <div v-if="openModificationModal" class="position-fixed full-screen-option backdrop-blur"></div>
        <div ref="modification-modal" class="modified-modal">
            <div v-if="openModificationModal" class="modal-content" style="height: calc(100vh - 100px);width: calc(100vw - 100px);">
                <header class="modal-header" ref="modal-modification-header">
                    <h5 class="modal-title font-18">{{modalTitle}}</h5>
                    <button type="button" aria-label="Close" class="close" @click="closeModification">×</button>
                </header>
                <div class="modal-body" ref="modal-modification-body">
                    <b-tabs
                        content-class="pt-3 pb-3 text-muted"
                        nav-class="nav-tabs-custom"
                    >
                        <b-tab title-item-class="mb-2">
                            <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                    <i class="bx bx-home"></i>
                                </span>
                                <span class="d-none d-sm-inline-block">
                                    Pending Items for Modification
                                </span>
                            </template>
                            <PendingModificationItems 
                                ref="pendingModifications"
                                :tableData="pendingRealignment" 
                                :draftRealignment="draftRealignment" 
                                @delete-item="deleteAlignmentItem" 
                                @delete-all-item="deleteAllItems"
                                @update-item="updateAlignmentItem"
                                @create-realignment="createRealignment" 
                                @remove-realignment="removeRealignment"
                                @post-realignment="postRealignment"
                            />
                        </b-tab>
                        <b-tab title-item-class="mb-2" @click="getPostedRealignments($store.state.data.cycle, $store.state.data.selectedDU.id)">
                            <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                    <i class="bx bx-home"></i>
                                </span>
                                <span class="d-none d-sm-inline-block">
                                    Posted Modification
                                </span>
                            </template>
                            <PostedModificationItems 
                                ref="postedModifications" 
                                @print-realignment="printRealignment" 
                                @view-modif-items="viewModifItems"
                                @view-logs="viewLogs"
                            />
                        </b-tab>
                        <b-tab title-item-class="mb-2" @click="getApprovedRealignments($store.state.data.cycle, $store.state.data.selectedDU.id)">
                            <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                    <i class="bx bx-home"></i>
                                </span>
                                <span class="d-none d-sm-inline-block">
                                    Approved Modification
                                </span>
                            </template>
                            <ApprovedModificationItems 
                                ref="tagApprovedRealignment" 
                                @print-realignment="printRealignment" 
                                @view-modif-items="viewModifItems"
                                @view-logs="viewLogs"
                            />
                        </b-tab>
                        <b-tab title-item-class="mb-2" @click="getReturnedRealignments($store.state.data.cycle, $store.state.data.selectedDU.id)">
                            <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                    <i class="bx bx-home"></i>
                                </span>
                                <span class="d-none d-sm-inline-block">
                                    Returned Items for Modification
                                </span>
                            </template>
                            <ReturnedModificationItems 
                                ref="returnedModifications" 
                                @print-realignment="printRealignment" 
                                @change-item="getItemResources($store.state.data.cycle, $store.state.data.selectedDepartment.id)"
                                @view-logs="viewLogs"
                            />
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
        </div>
        <print-options ref="printOpt"></print-options>
        <api-resource-logs ref="itemlog"></api-resource-logs>
        <profile-cropper ref="profileCropper" @crop-picture="cropData"></profile-cropper>
        <view-items ref="viewItems"></view-items>
        <RealignmentRemarks ref="realignmentRemarks"/>
    </Layout>
</template>